<template>
  <MainTemplate>
    <div class="mobile_top_wrap">
      <flex align="center" justify="between">
        <h1>Коворкинги <small v-if="paginate">{{ paginate.total }}</small></h1>
        <button class="filter__btn" @click="openFilter">
          <img src="../../assets/images/icons/filter.svg" alt="">
          <span>Фильтры</span>
        </button>
      </flex>
    </div>
    <preload-content :loading="!coworkings">
      <div class="mobile__hide">
        <flex align="center" mb="30px">
          <custom-select v-if="!!orders && filter.order" @change="(order) => filter.order = order" :value="filter.order" mr="20px">
            <option v-for="order in orders" :key="order.value" :value="order.value">{{ order.name }}</option>
          </custom-select>
          <custom-select v-if="!!getCities" @change="(city) => filter.city_id = city" :value="filter.city_id" mr="20px">
            <option value="" selected>Выберите город</option>
            <option v-for="city in getCities" :key="city.id" :value="city.id">{{ city.name }}</option>
          </custom-select>
          <custom-select
            mr="auto"
            v-if="!!specializations" @change="(specialization) => filter.specialization = specialization"
            :value="filter.specialization"
            width="300px"
            max-width="300px"
          >
            <option value="" selected>Выберите специализацию</option>
            <option v-for="specialization in specializations" :key="specialization.id" :value="specialization.id">{{ specialization.name }}</option>
          </custom-select>
          <search placeholder="Название или адрес коворкинга" v-model="filter.search"/>
        </flex>
      </div>
      <row v-if="coworkings && coworkings.length">
        <grid-item xs="12" md="6" lg="4" xl="3" v-for="coworking in coworkings" :key="coworking.id">
          <card
            :title="coworking.name"
            :preview="coworking.main_image ? coworking.main_image.path : null"
            :rate="coworking.rate"
            :address="coworking.city ? (coworking.city.name+', '+coworking.address) : coworking.address"
            :link="$router.resolve({name: 'coworking.show', params: {id: coworking.id}}).href"
            :tags="coworking.specializations"
          ></card>
        </grid-item>
      </row>
      <h3 style="text-align: center;margin-top: 50px" v-else>
        Список пуст
      </h3>
      <pagination v-if="paginate && paginate.last_page > 1" :current="paginate.current_page" :last="paginate.last_page" @click="(page) => filter.page = page"/>
    </preload-content>
  </MainTemplate>
</template>

<script>
import MainTemplate from '../../templates/MainTemplate'
import Row from '../../components/grid/Row'
import GridItem from '../../components/grid/GridItem'
import Card from '../../components/ui/card/card'
import Flex from '../../components/ui/flex'
import CustomSelect from '../../components/ui/inputs/custom-select'
import Search from '../../components/ui/inputs/search'
import Pagination from '../../components/ui/buttons/pagination'
import { mapGetters, mapMutations } from "vuex"
import preloadContent from '../../components/ui/preload-content';

export default {
  name: 'Catalog',
  components: {Pagination, Search, CustomSelect, Card, MainTemplate, Row, GridItem, Flex, preloadContent},
  computed: {
    ...mapGetters([
      'getCity',
      'getCities',
    ]),
    filterComputed() {
      return Object.assign({}, this.filter);
    }
  },
  watch: {
    filterComputed: {
      handler: function (newValue, oldValue) {
        if (newValue.page !== 1 && newValue.page === oldValue.page) return this.filter.page = 1;
        return this.loadCoworkings();
      },
      deep: true,
    },
  },
  mounted() {
    this.loadSpecializations();
    this.loadCoworkings();
  },
  data() {
    return {
      paginate: null,
      coworkings: null,
      specializations: null,
      orders: [
        {name: 'По рейтингу', value: 'rate,desc'},
        {name: 'Сначала новые', value: 'id,desc'},
        {name: 'Сначала старые', value: 'id,asc'},
      ],
      filter: {
        page: 1,
        order: 'rate,desc',
        city_id: this.$store.getters.getCity,
        specialization: null,
        search: null,
      },
    }
  },
  methods: {
    ...mapMutations(['openModal', 'setModalData']),
    loadSpecializations() {
      this.$api.specialization.all().then(({data}) => this.specializations = data);
    },
    loadCoworkings() {
      this.coworkings = null;
      let filter = this.filter;
      this.$api.coworking.list(Object.assign({
        column: filter.order.split(',')[0],
        direction: filter.order.split(',')[1]
      }, filter)).then((data) => {
        this.coworkings = data.data;
        this.paginate = data.meta;
      });
    },
    openFilter () {
      this.openModal('mobileFilters')
      this.setModalData('coworking')
    }
  }
}
</script>

<style scoped lang="scss">
.filter__btn {
  display: none;
}

@media screen and (max-width: 991px){
  h1 {
    font-size: 24px;
    padding-top: 0;
    margin-bottom: 0;
  }
  .filter__btn {
    font-family: "Open Sans", sans-serif;
    display: flex;
    align-items: center;
    border: none;
    background-color: transparent;
    font-weight: 600;
    font-size: 16px;
    color: #B9765B;
    img {
      margin-right: 5px;
    }
  }
  .mobile_top_wrap {
    padding: 20px 0;
  }
  .mobile__hide {
    display: none;
  }
}
</style>

